import React, {HTMLAttributes, RefAttributes} from "react";
import {IonSelect, IonSelectOption} from "@ionic/react";
import {JSX} from "react/jsx-runtime";
import IntrinsicAttributes = JSX.IntrinsicAttributes;
import {StyleReactProps} from "@ionic/react/dist/types/components/react-component-lib/interfaces";
import {
    IFloatFormItemProps,
    IFormItemElement,
    IIntFormItemProps,
    IStringFormItemProps, TextFormItem
} from "../model/FormModel";
import ErrorWrapperFE from "../form-element/ErrorWrapperFE";
import SimpleChoice from "../../../../ts/common/SimpleChoiceVO";

interface IProps extends IFormItemElement
{
    formItemProps:IStringFormItemProps|IFloatFormItemProps|IIntFormItemProps;
    choiceList?:SimpleChoice[];
    elementProps?: IntrinsicAttributes & React.ComponentProps<typeof IonSelect> & Omit<HTMLAttributes<HTMLIonSelectElement>, "style"> & StyleReactProps & RefAttributes<typeof IonSelect>
}

const SelectFIE = (props: IProps) =>
{
    let {
        form,
        formItemProps,
        label,
        onItemChange,
        children,
        instructions,
        elementProps
    } = props;

    const formItem = form.requireFormItem(formItemProps, formItemProps.type ?? "string", true) as TextFormItem;

    label = label ?? formItem.name;

    const onChange = (event:CustomEvent) => {
        if(!formItem.setValue(event.detail.value ?? "")){
            return;
        }

        if(onItemChange){
            onItemChange(formItem.itemID)
        } else if(onItemChange !== null){
            form.onFormItemChange(formItem.itemID)
        }
    }
    return <div className={form.isFormItemHidden(formItem) ? "d-none" : ""}>
        <ErrorWrapperFE
            formItem={formItem}
        >

            <fieldset>
                <div className="row">
                    <div className="col-12">
                        <label
                            className={"form-item-label" + (formItem.required ? " required" : "")}
                        >
                            {label}
                            <input id={formItem.itemID} className="d-none" />
                        </label>
                        <IonSelect
                            {...elementProps}
                            data-form-item-id={formItem.itemID}
                            labelPlacement={elementProps?.labelPlacement ?? "stacked"}
                            placeholder={elementProps?.placeholder ?? "Please select"}
                            className={'ion-touched ' + (formItem.errorText ? 'ion-invalid ' : '') + (elementProps?.className ?? "")}
                            name={formItem.itemID}
                            onIonChange={onChange}
                            value={formItem.value}
                        >

                            {!!props.choiceList && props.choiceList.map((choice, index) =>
                            {
                                return <IonSelectOption
                                    key={index}
                                    value={choice.id}
                                >
                                    {choice.name}
                                </IonSelectOption>
                            })}
                            {children}
                        </IonSelect>
                    </div>
                    {!!instructions && (
                        <div className="col-12">
                            <span className="instructions">{instructions}</span>
                        </div>
                    )}
                </div>
            </fieldset>

        </ErrorWrapperFE>
    </div>;
}

export default SelectFIE;